<div class="container">
  <div class="modal-container">
    <div class="content">
      <p *ngIf="!isRegistration" class="validacao-info">
        Para sua proteção enviaremos um código de segurança para o {{data.tipo === 'PHONE' ? 'celular' : 'e-mail'}} cadastrado.
      </p>
      <p  *ngIf="!isRegistration" class="validacao-info warning">
        <strong>Importante</strong>
        se este não é seu {{data.tipo === 'PHONE' ? 'número de celular' : 'e-mail'}} atualize em 
        <a class="link" href="javascript:void(0)" (click)="redirectPerfil()" >
          Perfil
        </a>
      </p>
      <p *ngIf="isRegistration" class="validacao-info">
        <strong *ngIf="data.tipo === 'PHONE'">Informe o número de celular com DDD</strong>
        <strong *ngIf="data.tipo === 'EMAIL' && data.funcionalidade === 'ALTERACAO'">Informe o novo e-mail</strong>
        <strong *ngIf="data.tipo === 'EMAIL' && data.funcionalidade === 'CADASTRO'">Informe o e-mail</strong>
      </p>

      <form [formGroup]="sendTokenForm" (submit)="!isTokenSended ? handleSendTokenByType($event) : handleResendToken($event)" class="send-token-form">
        <mat-form-field *ngIf="data.tipo === 'PHONE'" class="form-field phone" [hideRequiredMarker]="true" appearance="outline">
          <mat-label>DDD + Celular</mat-label>
          <input
            [autofocus]="true"
            matInput
            name="phone"
            id="phone"
            tabindex="1"
            formControlName="phone"
            [modelSemMascara]="true"
            mascara="(00) 00000-0000"
            placeholder="(00) 00000-0000"
            type="text"
            maxlength="15"
            inputmode="numeric"
            enterkeyhint="send"
          >
            <button
              *ngIf="(isRegistration) && this.sendTokenForm.get('phone').value?.length > 0 && (this.sendTokenForm.get('phone').value.length < 11 || this.sendTokenForm.get('phone').errors?.pattern )" 
              mat-icon-button 
              matSuffix
              type="button"
              (click)="this.sendTokenForm.get('phone').setValue('')">
              <mat-icon>cancel</mat-icon>
            </button>
            <button
              *ngIf="(isRegistration) && !this.sendTokenForm.get('phone').errors?.pattern && this.sendTokenForm.get('phone').value?.length === 11" 
              mat-icon-button 
              matSuffix
              class="btn-validated-phone"
              disabled=""
              type="button">
              <mat-icon>check_circle</mat-icon>
            </button>
            <mat-error *ngIf="(isRegistration) &&  this.sendTokenForm.get('phone').touched && this.sendTokenForm.get('phone').errors?.pattern">
              <mat-icon class="material-symbols-outlined">error</mat-icon> Informe um número de celular válido
            </mat-error>
        </mat-form-field>

        <mat-form-field *ngIf="data.tipo === 'EMAIL'" class="form-field phone" appearance="outline">
          <mat-label>Email</mat-label>
          <input
            matInput
            [autofocus]="true"
            name="email"
            id="email"
            formControlName="email"
            autocomplete="off"
            tabindex="1"
            type="email"
            enterkeyhint="send"
            autofocus
            placeholder="exemplo@email.com.br"
            pattern="^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$">
            <button
              *ngIf="(isRegistration) && this.sendTokenForm.get('email').value?.length > 0 && this.sendTokenForm.get('email').errors?.pattern" 
              mat-icon-button
              matSuffix
              type="button"
              (click)="this.sendTokenForm.get('email').setValue('')">
              <mat-icon>cancel</mat-icon>
            </button>
            <button
              *ngIf="(isRegistration) && this.sendTokenForm.get('email').value?.length > 0 && !this.sendTokenForm.get('email').errors?.pattern" 
              mat-icon-button  
              matSuffix
              class="btn-validated-phone"
              disabled=""
              type="button">
              <mat-icon>check_circle</mat-icon>
            </button>
            <mat-error *ngIf="hasAnyError('email')">
              <mat-icon class="material-symbols-outlined">error</mat-icon>
              Informe um e-mail válido
            </mat-error>
        </mat-form-field>

        <div class="send-token-actions">
          <button 
            mat-flat-button 
            color="primary" 
            class="send-btn"
            type="submit"
            enterkeyhint="send"
            [disabled]="disableSendTokenButton"
            [class.dynamic-margin]="hasAnyError('phone')">
            <ng-container *ngIf="!sendTokenLoader">
              {{ isTokenSended ? 'Reenviar código' : 'Enviar' }}
              <mat-icon class="material-symbols-outlined">send</mat-icon>
            </ng-container>
            <mat-icon class="spinner" *ngIf="sendTokenLoader">
              <mat-spinner diameter="20">
              </mat-spinner>
            </mat-icon>
          </button>

          <button *ngIf="isTokenSended && timerInProgress" [disabled]="disableResendToken" class="link-btn">
            Não recebi o código.
            <span *ngIf="timerInProgress"><strong>{{secondTicks}}s</strong></span>
          </button>
        </div>
      </form>

      <div *ngIf="isTokenSended" class="otp-container">
        <p *ngIf="!isRegistration" class="hint">
          Por favor digite o código que enviamos para o 
          {{data.tipo === 'PHONE' ? 'número informado' : 'e-mail cadastrado'}}:
        </p>
        <p *ngIf="isRegistration" class="hint">
          Por favor digite o código que enviamos para o 
          {{data.tipo === 'PHONE' ? 'número informado' : 'e-mail informado'}}:
        </p>

        <form #form="ngForm" class="otp-input" (submit)="handleConfirmTokenByType($event)">
          <div class="otp-form-field">
            <ng-otp-input (onInputChange)="onOtpChange($event)" [config]="{
                length: 6, 
                allowNumbersOnly: false, 
                inputClass: showTokenResponseError ? 'otp-error' : 'otp', 
                containerClass: 'containerClass'
              }">
            </ng-otp-input>
            <mat-error *ngIf="showTokenResponseError">
              <mat-icon class="material-symbols-outlined">error</mat-icon> {{showTokenResponseError}}
            </mat-error>
          </div>
          <button *ngIf="isTokenSended" [disabled]="!habilitarBotaoEnviar || sendTokenResponseError" enterkeyhint="send" type="submit" mat-flat-button color="primary">
            <mat-icon class="spinner" *ngIf="loading">
              <mat-spinner diameter="20">
              </mat-spinner>
            </mat-icon>
            <span *ngIf="!loading">Verificar</span>          
          </button>
        </form>
    

      </div>
    </div>
  </div>
</div>